export default "__VITE_ASSET__RcJrXHj5__"